"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.showtime", ["nucont.shared"]);
require("./showtime.routes");
